import { createAction } from '@reduxjs/toolkit';

import { LOAD_MARKETPLACE_DETAILED_ORDER } from './actionTypes';

export const loadMarketplaceDetailedOrder = createAction<string>(
  LOAD_MARKETPLACE_DETAILED_ORDER.BASE,
);
